import { useExtendedBasketData } from "@chef/state-management/hooks";
import { isGroceryProduct } from "@chef/helpers";
import { isNotEmptyArray } from "@chef/utils/array";

import type { WeekYear } from "@chef/types/common";

import { PickAndMixBasketList } from "../../lib/tiles/PickAndMixBasketList";
import { StandaloneProductList } from "../../lib/tiles/StandaloneProductBasketList";

import { intl } from "./WeekEditorConfirmOrderExperimental.Intl";

export const CartStep = ({ week, year }: WeekYear) => {
  const { data: extendedBasket } = useExtendedBasketData({
    week,
    year,
  });

  const groceryProducts =
    extendedBasket?.selectedProducts?.filter(isGroceryProduct);
  const hasStandaloneProducts =
    groceryProducts && isNotEmptyArray(groceryProducts);

  return (
    <section className="flex flex-col">
      <h1 className="mb-2 text-lg">{intl.MEALS}</h1>

      <PickAndMixBasketList week={week} year={year} />

      {hasStandaloneProducts && (
        <>
          <h1 className="mt-6 mb-2 text-lg">{intl.ADDONS}</h1>

          <StandaloneProductList week={week} year={year} />
        </>
      )}
    </section>
  );
};
